import { AbstractConnector } from "@web3-react/abstract-connector";
import { useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import { useCallback } from "react";
import styled from "styled-components";
import WhiteModal from "../../components/Modals/WhiteModal";
import { Body2, Heading6 } from "../../components/Typography";
import { CHAIN_ID } from "../../constants";
import { injected, walletconnect } from "../../constants/connectors";
import metamaskLogo from "../../images/logo-metamask.png";
import walletConnectLogo from "../../images/logo-walletconnect.png";
import { setupNetwork } from "../../utils";

const ConnectorsContainer = styled.div`
  display: flex;
  gap: 50px;
  align-items: center;
`;

const Connector = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex: 1 1 0;
  width: 0;
  cursor: pointer;
`;

const ConnectorName = styled.div`
  ${Heading6}
  text-align: center;
  @media (max-width: 576px) {
    ${Body2}
  }
`;

const ConnectorLogo = styled.img`
  width: 60%;

  @media (max-width: 456px) {
    width: 100%;
  }
`;

type Web3ConnectModalProps = {
  isOpen: boolean;
  handleClose?: () => void;
};

export default function Web3ConnectModal({ isOpen, handleClose }: Web3ConnectModalProps) {
  const { activate } = useWeb3React();

  const handleConnectorClick = useCallback(
    async (connector: AbstractConnector) => {
      if (connector instanceof InjectedConnector) {
        await setupNetwork(CHAIN_ID);
      }
      await activate(connector);
      if (handleClose) {
        handleClose();
      }
    },
    [activate, handleClose]
  );

  return (
    <WhiteModal title="Connect Your Wallet" isOpen={isOpen} handleClose={handleClose}>
      <ConnectorsContainer>
        <Connector onClick={() => handleConnectorClick(injected)}>
          <ConnectorLogo src={metamaskLogo} alt="connector" />
          <ConnectorName>Metamask</ConnectorName>
        </Connector>
        <Connector onClick={() => handleConnectorClick(walletconnect)}>
          <ConnectorLogo src={walletConnectLogo} alt="walletconnect" />
          <ConnectorName>Walletconnect</ConnectorName>
        </Connector>
      </ConnectorsContainer>
    </WhiteModal>
  );
}
